<dspx-card-set-base-form *ngIf="isServiceWorkerReady$ | async"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         [entityId]="id"
                         [model]="model"
                         formName="Inspection Calendar"
                         (onFormLoad)="formLoad($event)"
                         (onDialogSubmit)="handleDialogButtonClick($event, activeDialog)"
                         (onActionButtonClick)="handleActionButtonClick($event)"
                         (onFilter)="filterData($event)">
</dspx-card-set-base-form>
